require("./lib/ads");

var paywall = require("./lib/paywall");

setTimeout(() => paywall(10889766), 5000);

var $ = require("./lib/qsa");
require("./gallery");

if (window.IntersectionObserver) {
  var header = $.one(".splash");
  var headObserver = new IntersectionObserver(function([entry]) {
    header.classList.toggle("fade", entry.intersectionRatio < .5);
  }, { threshold: [0, .1, .2, .3, .4, .5, .6, .7, .8, .9] });
  headObserver.observe(header);
}

var backdrop = $.one(".backdrop");
var source = "loop.mp4";
if (window.matchMedia && window.matchMedia("(orientation: portrait)").matches) {
  source = "tall_loop.mp4";
}
backdrop.innerHTML = `<source src="./assets/${source}"></source>`